import React from "react";

import "./app.scss";

import Blogs from "./components/blogs";
import Contact from "./components/contact";
import Footer from "./components/footer";
import Intro from "./components/intro";
import Projects from "./components/projects";
import Projects2 from "./components/projects2";
import Skills from "./components/skills";
import About from "./components/about";
import GoToTopButton from "./components/goToTop/GoToTopButton";
const App = () => {
    return (
        <div>
            <Intro />
            <About />
            <Skills />
            <Projects />
            <Projects2 />
            <Blogs />
            <Contact />
            <Footer />
            <GoToTopButton />
        </div>
    );
};

export default App;
